const TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST = [
    "name",
    "headline",
    "subHeadline",
    "description",
    "visualHeroButtonText",
    "ruleNotice"
];
Object.freeze(TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST);
const EXTENDABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST = [
    "name",
    "description",
    "serviceTemplateIdentifiers",
    "ruleGroups",
    "rules",
    "ruleNotice",
    "isVisual",
    "visualType",
    "visualContentType",
    "isVisualDarkMode",
    "visualBlur",
    "visualHeroButtonText",
    "shouldForceToShowVisual"
];
Object.freeze(EXTENDABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST);
var EContentBlockerVisualType = /*#__PURE__*/ function(EContentBlockerVisualType) {
    EContentBlockerVisualType["Default"] = "default";
    EContentBlockerVisualType["Wrapped"] = "wrapped";
    EContentBlockerVisualType["Hero"] = "hero";
    return EContentBlockerVisualType;
}(EContentBlockerVisualType || {});
var EContentBlockerVisualContentType = /*#__PURE__*/ function(EContentBlockerVisualContentType) {
    EContentBlockerVisualContentType["Map"] = "map";
    EContentBlockerVisualContentType["VideoPlayer"] = "video-player";
    EContentBlockerVisualContentType["AudioPlayer"] = "audio-player";
    EContentBlockerVisualContentType["FeedText"] = "feed-text";
    EContentBlockerVisualContentType["FeedVideo"] = "feed-video";
    EContentBlockerVisualContentType["Generic"] = "generic";
    return EContentBlockerVisualContentType;
}(EContentBlockerVisualContentType || {});
var EContentBlockerTestStatus = /*#__PURE__*/ function(EContentBlockerTestStatus) {
    EContentBlockerTestStatus["Initial"] = "initial";
    EContentBlockerTestStatus["Running"] = "running";
    EContentBlockerTestStatus["Passed"] = "passed";
    EContentBlockerTestStatus["Failed"] = "failed";
    return EContentBlockerTestStatus;
}(EContentBlockerTestStatus || {});
/**
 * Represents the fields of a content blocker template.
 * Please also have a look at TemplateMetaDataField for base fields.
 */ var ContentBlockerField = /*#__PURE__*/ function(ContentBlockerField) {
    ContentBlockerField["Description"] = "description";
    ContentBlockerField["DescriptionTranslationFlags"] = "descriptionTranslationFlags";
    ContentBlockerField["ExampleEmbedCodes"] = "exampleEmbedCodes";
    ContentBlockerField["IsVisual"] = "isVisual";
    ContentBlockerField["IsVisualDarkMode"] = "isVisualDarkMode";
    ContentBlockerField["RuleGroups"] = "ruleGroups";
    ContentBlockerField["RuleNotice"] = "ruleNotice";
    ContentBlockerField["RuleNoticeTranslationFlags"] = "ruleNoticeTranslationFlags";
    ContentBlockerField["Rules"] = "rules";
    ContentBlockerField["ServiceTemplateIdentifiers"] = "serviceTemplateIdentifiers";
    ContentBlockerField["ShouldForceToShowVisual"] = "shouldForceToShowVisual";
    ContentBlockerField["TestPipelineId"] = "testPipelineId";
    ContentBlockerField["TestStatus"] = "testStatus";
    ContentBlockerField["VisualBlur"] = "visualBlur";
    ContentBlockerField["VisualContentType"] = "visualContentType";
    ContentBlockerField["VisualHeroButtonText"] = "visualHeroButtonText";
    ContentBlockerField["VisualHeroButtonTextTranslationFlags"] = "visualHeroButtonTextTranslationFlags";
    ContentBlockerField["VisualType"] = "visualType";
    return ContentBlockerField;
}(ContentBlockerField || {});
const EXPORT_REMOVABLE_CONTENT_BLOCKER = [
    "id",
    "logo",
    "logoId",
    "release",
    "releaseId",
    "extends",
    "next",
    "nextId",
    "pre",
    "preId",
    "extendsId",
    "translationIds",
    "extendedTemplateId",
    "translationInfo",
    "translatableRequiredFields",
    "translatedRequiredFields",
    "translatableOptionalFields",
    "translatedOptionalFields",
    "translationFlaggedFields",
    "version"
];
Object.freeze(EXPORT_REMOVABLE_CONTENT_BLOCKER);
export { ContentBlockerField, EContentBlockerTestStatus, EContentBlockerVisualContentType, EContentBlockerVisualType, EXPORT_REMOVABLE_CONTENT_BLOCKER, EXTENDABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST };
